// C6 (mockups p01, p02): an island of a pack the family doesn't own, on the Map. The 3D island
// still shows, under its wrapping; its acts, sounds and voices are the pack's (worker/paid.ts). A
// child asks a grown-up (a `pack.asked` event, in the grown-up's Needs-you); a grown-up opens
// "Unwrap" (organiser/PackSheets). No price and no store link on a child's phone.
import { useState } from 'react'
import type { Person } from '../../shared/events'
import type { Pack } from '../../shared/pack/schema'
import { openOverlay } from '../app/router'
import { useToast } from '../app/toast'
import { record } from '../data/events'
import { useEvents } from '../data/progress'
import { askedFor, type CatalogueEntry } from '../domain/packs'
import { PLACES } from '../map/places/registry'
import { t } from '../strings/en'

const p = t.packs

export function WrappedIsland({ pack, trip, person, islandId }: { pack: CatalogueEntry; trip: Pack; person: Person; islandId: string }) {
  const events = useEvents()
  const [asking, setAsking] = useState(false)
  const island = PLACES.find((x) => x.id === islandId)?.title ?? islandId
  const freeIsland = PLACES.find((x) => x.id === pack.freeIslandId)?.title ?? pack.freeIslandId
  const freeDeck = trip.decks.find((d) => d.id === pack.freeLanguageUnitId)?.title ?? pack.freeLanguageUnitId
  const child = person.kind === 'child'
  const asked = asking || askedFor(events, person.id, pack.id)
  return (
    <section className="panel wrapped-card" aria-label={p.stillWrapped(island)}>
      <span className="wrapped-bow" aria-hidden>
        🎀
      </span>
      <h2 className="h2">{p.stillWrapped(island)}</h2>
      <p className="muted">{child ? p.childSub(pack.name) : p.grownUpSub(pack.name)}</p>
      {child ? (
        <button
          className="btn y press"
          disabled={asked}
          onClick={() => {
            setAsking(true)
            void record('pack.asked', { packId: pack.id }, person.id).then(() => useToast.getState().show(p.askedToast))
          }}
        >
          {asked ? p.asked : p.ask}
        </button>
      ) : (
        <button className="btn y press" onClick={() => openOverlay(`unlock:${pack.id}`)}>
          {p.unwrapPack(pack.name)}
        </button>
      )}
      <p className="caption">{p.stillFree(freeIsland, freeDeck)}</p>
    </section>
  )
}
